import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './user-deactivate-portal-access-confirmation.scss';
import ModalForm from '../_global/modal-form/modal-form';
import ConfirmationMessage from '../confirmation-message/confirmation-message';
import { ButtonColor } from '@ampol/design-system';
import Env from 'Env';
import { adminDeleteUser, deleteUser } from 'actions/userActions';
import { trackCustomEvent } from 'utilities/app-insights';

const UserDeactivatePortalAccessConfirmation = ({ onClose, selectedUser }) => {
  const dispatch = useDispatch();

  const isAdminPortal = Env.isAdminPortal();
  const assignedGrandfatherClientNumber = useSelector(state => state.userStore.assignedGrandfatherClientNumber);
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state) => state.userStore.assignedAccountNumber);

  const confirmationMessage = 'Are you sure you wish to deactivate portal access for this user?';

  const handleSubmitClick = () => {
    trackCustomEvent('Submit Deactivate User', loggedInUser, assignedAccountNumber, 'Clicked Deactivate to submit deactivate user.', { selectedUserEmail: selectedUser?.emailId, selectedUserId: selectedUser?.userId, });

    if (isAdminPortal) {
      dispatch(adminDeleteUser(selectedUser));
    } else {
      dispatch(deleteUser(
        assignedGrandfatherClientNumber,
        selectedUser
      ));
    }

    onClose();
  };

  return <>
    <ModalForm
      title="Deactivate Portal Access"
      closeForm={onClose}
      submitClick={handleSubmitClick}
      submitLabel={'Confirm'}
      cancelLabel={'Cancel'}
      canSubmit={true}
      isSubmitVisible={true}
      submitColor={ButtonColor.Blue}
      cancelColor={ButtonColor.Blue}
    >
      <div>
        <ConfirmationMessage message={confirmationMessage}/>
      </div>
    </ModalForm>
  </>;
};

export default UserDeactivatePortalAccessConfirmation;
